import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { Container } from "./Container";
import { LanguageSelector } from "./LanguageSelector";
import { ThemeToggle } from "../common/ThemeToggle";
import { Logo } from "../common/Logo";
import { buttonClasses } from "../common/Button";
import { useAuth } from "~/lib/auth/useAuth";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `text-sm font-semibold transition hover:text-text-full ${
    isActive ? "text-text-full" : "text-text-medium"
  }`;

export const Header = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, signIn, signUp, signOut } = useAuth();

  return (
    <header className="sticky top-0 z-30 border-b border-border-shell bg-surface-sari">
      <Container>
        <div className="relative flex h-16 items-center justify-between">
          <Logo />

          <nav className="absolute left-1/2 hidden -translate-x-1/2 items-center gap-8 md:flex">
            <NavLink to="/services" className={navLinkClass}>
              {t("Header.services")}
            </NavLink>
            <NavLink to="/merchants" className={navLinkClass}>
              {t("Header.merchants")}
            </NavLink>
            <NavLink to="/about" className={navLinkClass}>
              {t("Header.about")}
            </NavLink>
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <LanguageSelector />
            <ThemeToggle />
            {!isLoading &&
              (isAuthenticated ? (
                <button
                  type="button"
                  onClick={signOut}
                  className={buttonClasses("outline", "sm")}
                >
                  {t("Header.sign-out")}
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={signIn}
                    className={buttonClasses("outline", "sm")}
                  >
                    {t("Header.sign-in")}
                  </button>
                  <button
                    type="button"
                    onClick={signUp}
                    className={buttonClasses("primary", "sm")}
                  >
                    {t("Header.sign-up")}
                  </button>
                </>
              ))}
          </div>
        </div>
      </Container>
    </header>
  );
};
